import { Instance } from '@const/consts'

const domainGlobal = 'https://share.docuforce.ilsglobal.vn/'
const domainRU = 'https://share.docuforce.infologistics.ru/'
const domainBR = 'https://share.docuforce.ilsbrasil.com/'
const domainZA = 'https://share.ilssa.africa/'
const domainVI = 'https://share.docuforce.ilsglobal.vn/'

export const dropdownItems = [
  {
    name: Instance.GLOBAL,
    translation: domainGlobal
  },
  {
    name: Instance.BR,
    translation: domainBR + Instance.BR
  },
  {
    name: Instance.RU,
    translation: domainRU
  },
  {
    name: Instance.ZA,
    translation: domainZA
  },
  {
    name: Instance.VIETNAMESE,
    translation: domainVI
  }
]
